// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
export const lightEffects = {
  elevation: {
    surface: {
      overlay: "rgba(0, 0, 0, 0.10196078431372549) 0px 4px 24px 0px",
      raised: "rgba(0, 0, 0, 0.0392156862745098) 0px 4px 8px 0px",
      sunken: "rgba(0, 0, 0, 0.0196078431372549) 0px 0px 12px 0px inset",
    },
  },
};
export const darkEffects = {
  elevation: {
    surface: {
      sunken: "rgba(255, 255, 255, 0.12156862745098039) 0px 0px 8px 0px inset",
      raised: "rgba(35, 31, 56, 0.1607843137254902) 0px 1px 16px 0px",
      overlay: "rgba(0, 0, 0, 0.1803921568627451) 0px 4px 24px 0px",
    },
  },
};

export type Effects = typeof lightEffects;
